// extracted by mini-css-extract-plugin
export default {"root":"logoBoxDisplay_root__431hL","inner":"logoBoxDisplay_inner__ClULT","profilePic":"logoBoxDisplay_profilePic__1d2Qh","isPlaceholder":"logoBoxDisplay_isPlaceholder__UTRIA"};